// app/ai-use-cases/[id]/error.tsx
'use client';

import { useEffect } from 'react';

import { ErrorPage } from '@/components/error-page';
import { SiteFooter } from '@/components/site-footer';
import { SiteHeader } from '@/components/site-header';

export default function UseCaseError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Use case page error:', error);
  }, [error]);

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <SiteHeader />
      
      <main className="container mx-auto px-4 py-10">
        <ErrorPage 
          title="Error Loading Use Case" 
          message="We're having trouble loading this use case. The content may be temporarily unavailable or still in development."
          code={error.digest || 'USE_CASE_ERROR'}
          retry={reset}
        />
      </main>
      
      <SiteFooter />
    </div>
  );
} 